export default __webpack_public_path__ + "static/media/third.422a298e.png";